export default "__VITE_ASSET__BJ28VnSF__"